'use client';

import { type NodeProps } from '@xyflow/react';
import { NodeShell } from '../BaseNode';
import { usePipelineStore } from '@/lib/pipeline/store';

export default function PreviewNode({ id }: NodeProps) {
  const rt = usePipelineStore((s) => s.runtime[id]);
  const out = rt?.output as { image?: string; video?: string; text?: string } | undefined;

  return (
    <NodeShell id={id} type="preview">
      {out?.video ? (
        // eslint-disable-next-line jsx-a11y/media-has-caption
        <video src={out.video} controls className="rounded-lg w-full nodrag" />
      ) : out?.image ? (
        // eslint-disable-next-line @next/next/no-img-element
        <img src={out.image} alt="preview" className="rounded-lg w-full" />
      ) : out?.text != null ? (
        <div className="nowheel text-sm whitespace-pre-wrap break-words max-h-48 overflow-y-auto bg-[var(--bg-base)] rounded-lg p-2">
          {out.text}
        </div>
      ) : (
        <div className="text-xs text-[var(--text-muted)] py-8 text-center">
          Connect any output (image / text / video) and Run
        </div>
      )}
    </NodeShell>
  );
}
